import { render, staticRenderFns } from "./ParentGroupComponent.vue?vue&type=template&id=0b0315ec&scoped=true"
import script from "./ParentGroupComponent.vue?vue&type=script&lang=ts"
export * from "./ParentGroupComponent.vue?vue&type=script&lang=ts"
import style0 from "./ParentGroupComponent.vue?vue&type=style&index=0&id=0b0315ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0315ec",
  null
  
)

export default component.exports